@for (reference of references; track reference.referenceNumber) {
  <tt-reference-card [attr.data-testid]="'node-detail-popover-references_reference-card-' + reference.id" [reference]="reference" />
}
